import { I18n } from 'react-redux-i18n-lite';
import { ROLE } from '../const';

const ROLE_CHIP_TRANSLATION_KEYS = {
  [ROLE.COINSTRUCTOR]: 'classroom.guest',
  [ROLE.STUDENT]: 'classroom.student',
  [ROLE.INSTRUCTOR]: 'classroom.instructor'
};

export function getRoleChipLabel(globalRole, classroomRole) {
  if (!classroomRole || classroomRole === globalRole) {
    return '';
  }

  const translationKey = ROLE_CHIP_TRANSLATION_KEYS[classroomRole];
  return translationKey ? I18n.t(translationKey) : '';
}

export function isClassroomPath(pathname) {
  return /\/classroom\/[a-zA-Z0-9.-]+/.test(pathname);
}

export function extractClassroomIdFromPath(pathname) {
  const match = pathname.match(/\/classroom\/([a-zA-Z0-9.-]+)/);
  return match ? match[1] : null;
}

export function findClassroomRole(classroomId, activeClassrooms, selectedClassroom) {
  if (selectedClassroom && selectedClassroom.id === classroomId && selectedClassroom.role) {
    return selectedClassroom.role;
  }

  const classroom = (activeClassrooms || []).find(item => item.id === classroomId);
  return classroom ? classroom.role : undefined;
}

export function isClassroomRolePending(pathname, activeClassrooms, selectedClassroom, classroomsFetching) {
  if (!isClassroomPath(pathname)) {
    return false;
  }

  const classroomId = extractClassroomIdFromPath(pathname);
  if (!classroomId) {
    return false;
  }

  if (findClassroomRole(classroomId, activeClassrooms, selectedClassroom)) {
    return false;
  }

  return classroomsFetching || !selectedClassroom || selectedClassroom.id !== classroomId;
}

export function resolveRoleForPath(pathname, globalRole, activeClassrooms, selectedClassroom) {
  if (!isClassroomPath(pathname)) {
    return globalRole;
  }

  const classroomId = extractClassroomIdFromPath(pathname);
  if (!classroomId) {
    return globalRole;
  }

  const classroomRole = findClassroomRole(classroomId, activeClassrooms, selectedClassroom);
  return classroomRole || globalRole;
}
